module.exports = __webpack_public_path__ + "static/media/planejarRotasDisabled.550da0a6.svg";